import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import type { PublicClientApplication } from "@azure/msal-browser";
import { loadAppConfig } from "@shell/auth/authConfig";
import { createMsalInstance } from "@shell/auth/msalInstance";
import { App } from "./App";

const rootEl = document.getElementById("root");
if (!rootEl) {
    throw new Error("Root element #root not found in index.html");
}

const config = loadAppConfig();
const msalInstance: PublicClientApplication = createMsalInstance(config);
await msalInstance.initialize();

// `handleRedirectPromise` must run on every page load (not only after a
// known sign-in click) because Entra returns the auth code via redirect.
// The promise resolves to null on a non-redirect load, which is the
// correct no-op.
const redirectResponse = await msalInstance.handleRedirectPromise();
if (redirectResponse?.account) {
    msalInstance.setActiveAccount(redirectResponse.account);
}

if (msalInstance.getActiveAccount() === null) {
    const first = msalInstance.getAllAccounts()[0];
    if (first !== undefined) {
        msalInstance.setActiveAccount(first);
    }
}

createRoot(rootEl).render(
    <StrictMode>
        <App msalInstance={msalInstance} config={config} />
    </StrictMode>,
);
